import { useEffect } from 'react';

export function DocumentTitle({ title }: { title: string }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);

  return null;
}
